export default "__VITE_ASSET__d4842846__"